type KeyHandlerOptions<T> = {
    keys: string[];
    preventDefault: boolean;
    action: (event: React.KeyboardEvent<T> | KeyboardEvent) => void | Promise<void>;
    stopPropagation?: boolean;
};

export const createKeyDownHandler = <T extends HTMLElement>({
                                                                keys,
                                                                preventDefault,
                                                                action,
                                                                stopPropagation
                                                            }: KeyHandlerOptions<T>) => {
    return async (event: React.KeyboardEvent<T> | KeyboardEvent) => {
        if (keys.includes(event.key)) {
            if (preventDefault) event.preventDefault();
            if (stopPropagation) event.stopPropagation();
            await action(event);
        }
    };
}